import React, {useEffect} from 'react';
import {Box, Divider, Drawer, List, ListItem, ListItemText, Typography} from '@mui/material';
import './SideMenu.style.scss';
import {Link, useNavigate} from "react-router-dom";
import Languages from "../Language/Languages";
import {useLogOutMutation} from "../../stores/account/account.api";
import MyAccountBalance from "../MyAccountBalance/MyAccountBalance";
import ContactUs from "../ContactUs/ContactUs";
import useAppModalService from "../../hooks/useAppModalService";
import {FormattedMessage} from "react-intl";
import {useSelector} from "react-redux";
import {selectUserAccount, selectUserIsAuthenticated} from "../../stores/account/account.selectors";
import LoginButton from "../../views/PopUps/LoginPopUp/LoginButton";
import GlobalConst from "../../constants/GlobalConst";
import {ModalType} from "../AppModal/ModalTypes";
import OnBoardingPopUp from "../../views/PopUps/OnBoardingPopUp/OnBoardingPopUp";

const SideMenu = ({open, onClose}) => {

    const navigate = useNavigate();
    const [logOut] = useLogOutMutation();
    const {openModal, closeModal, modalStack, stackSize} = useAppModalService();
    const isUserAuthenticated = useSelector(selectUserIsAuthenticated)
    const userAccount = useSelector(selectUserAccount);

    const handleLinkClick = (str) => {
        navigate(`${str}`);
        onClose();
    };

    const handleRedirectMyAccountClick = (str) => {
        window.location.href = `${GlobalConst.SITE_URLS.TRADEFAN}/MyAccount/#${str}?pickx=1`;
        onClose();
    }

    const handleLogout = () => {
        logOut();
        onClose();
    };

    const handleContactUsClick = async () => {
        await openModal('contactUs', ModalType.CUSTOM, {
            modalComponent: ContactUs
        });
    };

    const handleOnboardingClick = async ()=>{
        await openModal("onBoardingPopUp", ModalType.CUSTOM, {
            modalComponent: OnBoardingPopUp
        })
    }

    return (
        <Drawer anchor="left" open={open} onClose={onClose}>
            <div className="sideMenu">
                <div className={"closeButton"} onClick={onClose}>X</div>
                <Box className="menuHeader">
                    <div className={"navLogo"} onClick={onClose}/>
                    {/*<Typography variant="body2" className="liveFantasy">
                        <Link to={`${GlobalConst.SITE_URLS.TRADEFAN}`}>
                            <FormattedMessage id={"navigationHeader.liveFantasy"}/>
                        </Link>
                    </Typography>*/}
                </Box>
                <List>
                    <ListItem onClick={() => handleLinkClick('/lobby')}>
                        <ListItemText className="listMenuItem"><FormattedMessage
                            id={"navigationHeader.lobby"}/></ListItemText>
                    </ListItem>



                    <ListItem onClick={() => handleLinkClick('/howtoplay')}>
                        <ListItemText className="listMenuItem"><FormattedMessage
                            id={"navigationHeader.howToPlay"}/></ListItemText>
                    </ListItem>
                    {isUserAuthenticated && <ListItem onClick={() => handleLinkClick('/myaccount/mypicks/ongoing')}>
                        <ListItemText className="highlighted listMenuItem"><FormattedMessage
                            id={"navigationHeader.myAccount.myPicks"}/></ListItemText>
                    </ListItem>}
                    <ListItem onClick={() => handleLinkClick('/faq')}>
                        <ListItemText className="listMenuItem"><FormattedMessage id={"navigationHeader.faq"}/>
                        </ListItemText>
                    </ListItem>

                    <ListItem className="menu-item"
                              onClick={() => handleOnboardingClick()}>
                        <ListItemText className="listMenuItem">
                            <FormattedMessage id={"navigationHeader.onboarding"}/> <div className={"icon-video"}></div>
                        </ListItemText>
                    </ListItem>

                    <ListItem className="contactUs" onClick={() => {
                        handleContactUsClick();
                        onClose();
                    }}>
                        <ListItemText className="listMenuItem"><FormattedMessage id={"navigationHeader.contactUs"}/>
                        </ListItemText>
                    </ListItem>


                </List>
                <Divider/>
                {isUserAuthenticated && <MyAccountBalance onSideMenu/>}
                {isUserAuthenticated && <Divider/>}
                {isUserAuthenticated && <List>
                    <ListItem onClick={() => handleLinkClick('/myaccount/myprofile')}>
                        <ListItemText className="listMenuItem"><FormattedMessage
                            id={"navigationHeader.myAccount.myProfile"}/> </ListItemText>
                    </ListItem>
                    <ListItem onClick={() => handleLinkClick('/myaccount/transactionhistory')}>
                        <ListItemText className="listMenuItem"><FormattedMessage
                            id={"navigationHeader.myAccount.transactions"}/> </ListItemText>
                    </ListItem>
                    <ListItem onClick={() => GlobalConst.FEATURES.ENABLE_LEGACY_PAGES ? handleRedirectMyAccountClick('WithdrawFunds') : handleLinkClick('/myaccount/withdrawfunds')}>
                        <ListItemText className="listMenuItem"><FormattedMessage
                            id={"navigationHeader.myAccount.withdrawFunds"}/>
                        </ListItemText>
                    </ListItem>
                    <ListItem className="languageSection">
                        <Languages onClose={onClose}/>
                    </ListItem>
                    <ListItem onClick={() => handleLogout()}>
                        <ListItemText className="listMenuItem"><FormattedMessage
                            id={"navigationHeader.myAccount.logout"}/></ListItemText>
                    </ListItem>
                </List>}
                {!isUserAuthenticated && <LoginButton onClose={onClose}/>}
                <Box className="footer">
                    <Typography className='allRightReserved' variant="caption">2024 © TradeFan Inc. <FormattedMessage id="footer.rightsReserved"/> </Typography>
                    <Box className="footerLinks">
                        <Typography className="termsOfUse" variant="caption" onClick={() => {
                            navigate('TermsOfUse');
                            onClose();
                        }}><FormattedMessage id="footer.termsOfUse"/> </Typography>
                        <Typography className="privacyPolicy" variant="caption" onClick={() => {
                            navigate('PrivacyPolicy');
                            onClose();
                        }}><FormattedMessage id="footer.privacyPolicy"/> </Typography>
                    </Box>
                </Box>
            </div>
        </Drawer>
    );
};

export default SideMenu;
